
import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { startListadoItemsCompra } from "../../../services";





export const useItemsCompraQuery = () => {
    const [page, setPage] = useState(0);
    const [termino, setTermino] = useState('');

    const { data, isLoading } = useQuery({
        queryKey: ['items-compra', { page, termino }], 
        queryFn: () => startListadoItemsCompra({ page, termino }),
    });
    

    const chagePage = (num) => {
        setPage(num - 1);
    }

    const chageTermino = (valor) => {
        setPage(0);
        setTermino(valor)
    }

    
    return {
        // Estados
        page,
        termino,
        // Metodos
        chagePage,
        chageTermino,
        data, isLoading,
    }
}
